import { schemes, zSchema } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const deletePaymentItemSchema = zSchema.object({
  companyID: schemes.companyID(),
  paymentItemID: schemes.uuid(),
});

export type TDeletePaymentItemRequest = zSchema.infer<
  typeof deletePaymentItemSchema
>;

export const deletePaymentItem = (axios: IAxiosInstance) => {
  return async (params: TDeletePaymentItemRequest) => {
    await axios.noRetry.delete("payment-items", {
      params: {
        companyID: params.companyID,
        paymentItemID: params.paymentItemID,
      },
    });
  };
};
